import { Module } from "vuex";
import { IActions, IGetters, IMutations, IBranchState } from "./branch.type";
import delay from "@/utils/delay";

export const getters: IGetters = {
    // getId: (state) => {
    //     return state.sale?.id;
    // },
};

export const mutations: IMutations = {
    // setLoading: (state, payload) => {
    //     state.loading = payload;
    // },
    setBranch: (state, payload) => {
        state.branch = payload;
    },
    // setCustomers: (state, payload) => {
    //     state.customers = payload;
    // },
};

export const actions: IActions = {
    async setBranch(this, context, payload): Promise<void> {
        context.commit("setBranch", payload);

        try {
            // load inventory and price
            const branchCode = parseInt(payload.code);
            context.commit("catalog/setLoading", true, {
                root: true,
            });
            await this.$services.catalog.getInventory(branchCode);
            await this.$services.catalog.getPrice(branchCode);
            this.$services.catalog.mergePrice(branchCode);
            this.$services.catalog.mergeInventory(branchCode);
            context.commit("allProduct/reset", true, {
                root: true,
            });
            context.commit("catalog/setLoading", false, {
                root: true,
            });
            await delay(1000);
            context.dispatch("allProduct/loadMore", true, {
                root: true,
            });
        } catch (error) {
            console.warn(error);
        }
    },
    // async syncSale(this, context, payload): Promise<void> {
    //     console.log("syncSale:", payload);
    //     try {
    //         context.commit("setLoading", true);
    //         const u = await this.$services.sales.syncSale(payload);
    //         context.commit("setSale", u.data());
    //         console.log(u.customerList());
    //         context.commit("setCustomers", u.customerList());
    //     } catch (error) {
    //         console.warn(error);
    //     } finally {
    //         context.commit("setLoading", false);
    //     }
    // },
    // async addNewCustomer(this, context, payload): Promise<void> {
    //     console.log("addNewCustomer", payload, context.rootGetters["sale"]);
    //     const c = await this.$services.customers.createCustomer(
    //         payload,
    //         context.state.sale!.id!
    //     );

    //     console.log("new customer: ", c);

    //     // TODO update customer
    //     c.basketID = c.id;
    //     const nc = await this.$services.customers.updateCustomer(
    //         c.data()
    //     )

    //     const list = [...context.state.customers, nc];
    //     context.commit("setCustomers", list);
    // },
};

const branch: Module<IBranchState, IBranchState> = {
    namespaced: true,
    state: {
        branch: {
            name: "Sukhumvit 33",
            nameTh: "สุขุมวิท 33",
            distance: "3.0 km",
            latlng: [13.73204799, 100.56762289],
            address: "595 Sukhumvit Rd",
            subDistrict: "North Khlong Ton",
            district: "Vadhana",
            addressTh: "595 ถนนสุขุมวิท แขวงคลองตันเหนือ เขตวัฒนา",
            province: "Bangkok",
            provinceTh: "กรุงเทพมหานคร",
            postcode: "10110",
            phoneNumber: "061-002-0199",
            active: false,
            locationUrl:
                "https://www.google.co.th/maps/place/Villa+Market+-+Sukhumvit+33,+%E0%B8%96%E0%B8%99%E0%B8%99+%E0%B8%AA%E0%B8%B8%E0%B8%82%E0%B8%B8%E0%B8%A1%E0%B8%A7%E0%B8%B4%E0%B8%97+%E0%B9%81%E0%B8%82%E0%B8%A7%E0%B8%87+%E0%B8%84%E0%B8%A5%E0%B8%AD%E0%B8%87%E0%B8%95%E0%B8%B1%E0%B8%99%E0%B9%80%E0%B8%AB%E0%B8%99%E0%B8%B7%E0%B8%AD+Bangkok,+%E0%B8%81%E0%B8%A3%E0%B8%B8%E0%B8%87%E0%B9%80%E0%B8%97%E0%B8%9E%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%99%E0%B8%84%E0%B8%A3/@13.73457,100.5798123,17z/data=!4m5!3m4!1s0x30e29f0213378137:0x19a1ece8c2a0dd2f!8m2!3d13.732087!4d100.567631",
            code: "1000",
            online: true,
            hub: "1000",
        },
    },
    getters,
    mutations,
    actions,
};

export default branch;
